import { render, staticRenderFns } from "./SubTopic.vue?vue&type=template&id=ac2037bc&scoped=true&"
import script from "./SubTopic.vue?vue&type=script&lang=js&"
export * from "./SubTopic.vue?vue&type=script&lang=js&"
import style0 from "./SubTopic.vue?vue&type=style&index=0&id=ac2037bc&lang=scss&scoped=true&"
import style1 from "./SubTopic.vue?vue&type=style&index=1&id=ac2037bc&scoped=true&lang=css&"
import style2 from "./SubTopic.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2037bc",
  null
  
)

export default component.exports